import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface PriceConfiguration {
    id: string;
    name: string;
    priceField: string;
    percentage: number;
    isActive: boolean;
}

export interface ConfigurationResponse {
    prices: PriceConfiguration[];
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService {

    constructor(private http: HttpClient) { }

    getConfiguration(): Observable<ConfigurationResponse> {
        return this.http.get<ConfigurationResponse>(`api/configuration`);
    }
}